export default "__VITE_ASSET__DGutdEqI__"